import Pharmacy from "./Pharmacy";

export default Pharmacy;
